import { ColumnProps, ColumnType } from 'antd/lib/table'
import { SetStateAction, Dispatch } from 'react'
import { ResizableProps, Resizable, ResizeCallbackData } from 'react-resizable'

import { ColumnConstraintsType } from './types'

export const ResizeableTableHeader = (props: ResizableProps) => {
    const {
        onResize,
        width,
        draggableOpts,
        minConstraints,
        maxConstraints,
        ...restProps
    } = props

    if (!width) {
        return <th {...restProps} />
    }

    const newDraggableOpts = { ...draggableOpts, enableUserSelectHack: false }

    return (
        <Resizable
            width={width}
            height={10}
            onResize={onResize}
            draggableOpts={newDraggableOpts}
            resizeHandles={['e']}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={e => {
                        e.stopPropagation()
                    }}
                />
            }
            minConstraints={minConstraints}
            maxConstraints={maxConstraints}
        >
            <th {...restProps} />
        </Resizable>
    )
}

// eslint-disable-next-line comma-spacing
export const handleColumnResize = <T,>(
    setColumnsState: Dispatch<SetStateAction<Array<ColumnProps<T>>>>,
    index: number,
    { size }: ResizeCallbackData,
) => {
    setColumnsState((prevColumns: Array<ColumnProps<T>>) => {
        const nextColumns = [...prevColumns]

        nextColumns[index] = {
            ...nextColumns[index],
            width: Math.round(size.width),
        }
        return nextColumns
    })
}

// eslint-disable-next-line comma-spacing
export const getResizeableTableColumns = <T,>(
    columnsState: ColumnType<T>[],
    resizeHandler: (index: number, data: ResizeCallbackData) => void,
    constraints?: ColumnConstraintsType,
): ColumnType<T>[] => {
    return columnsState.map((col, index) => ({
        ...col,
        onHeaderCell: ((column: ColumnProps<T>) => {
            const columnKey = column.key
            let minConstraints = undefined
            let maxConstraints = undefined

            if (columnKey && constraints) {
                if (constraints[columnKey]?.min) {
                    minConstraints = [
                        constraints[columnKey].min,
                        constraints[columnKey].min,
                    ]
                }
                if (constraints[columnKey]?.max) {
                    maxConstraints = [
                        constraints[columnKey].max,
                        constraints[columnKey].max,
                    ]
                }
            }

            return {
                width: column.width,
                minConstraints,
                maxConstraints,
                onResize: (event: MouseEvent, data: ResizeCallbackData) =>
                    resizeHandler(index, data),
            }
        }) as any,
    }))
}
